import NotificationsActiveIcon from "@mui/icons-material/NotificationsActiveOutlined";
import { Button } from "@mui/material";
import { isEmpty } from "lodash-es";
import { useCallback } from "react";
import { useSupabaseLoader } from "../../../../../server/supabase/hooks";
import { useDialog } from "../../../../../utils/hooks/use-dialog";
import { FollowUpRecurringUnsupportedDialog } from "./follow-up-recurring-unsupported-dialog";
import { ShowFollowUpMomentsDialog } from "./show-follow-up-moments-dialog";

import type { UUID } from "../../../../../utils/uuid";
import type { FollowUpMomentDetails } from "../../../../follow-up/server/types";
import type { FC } from "react";

export const MomentFormCreateFollowUpButton: FC<{
  momentId: UUID;
  saving?: boolean;
  isRecurring: boolean;
}> = ({ momentId, saving, isRecurring }) => {
  const momentsDialog = useDialog();
  const recurringDialog = useDialog();

  const { data: existing, loading: existingLoading } = useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const { data, error } = await supabase
        .rpc("moment_existing_follow_ups", {
          account_id_: account_id,
          moment_id_: momentId,
        })
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    [momentId],
  );

  const { handleClose: existingClose } = momentsDialog;

  const loadFollowUpData = useCallback(
    (details: FollowUpMomentDetails) => {
      existingClose();
      window.open(`/follow-up/moment/${details.id}`, "_blank");
    },
    [existingClose],
  );

  return (
    <>
      <Button
        data-analytics-id="moment-form-create-follow-up-button"
        disabled={false}
        loading={existingLoading || saving}
        variant="outlined"
        onClick={() => {
          if (isRecurring) {
            recurringDialog.handleOpen();
          } else if (existing) {
            momentsDialog.handleOpen();
          } else {
            window.open(`/follow-up/moment/${momentId}`, "_blank");
          }
        }}
        sx={{ ml: 1 }}
        startIcon={<NotificationsActiveIcon />}
      >
        {`Follow-Up${!isEmpty(existing) ? ` (${existing.follow_ups?.length})` : ""}`}
      </Button>
      {existing && (
        <ShowFollowUpMomentsDialog
          open={momentsDialog.open}
          onClose={momentsDialog.handleClose}
          data={existing}
          onCreateFollowUp={loadFollowUpData}
        />
      )}
      <FollowUpRecurringUnsupportedDialog
        open={recurringDialog.open}
        onClose={recurringDialog.handleClose}
        momentId={momentId}
      />
    </>
  );
};
